import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { history, fetchWrapper } from '_helpers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// create slice

const name = 'likewriter';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState,  extraReducers });

// exports

export const likewriterActions = { ...slice.actions, ...extraActions };
export const likewriterReducer = slice.reducer;

// implementation

function createInitialState() {
    const storedHomework = localStorage.getItem('likewriter');
    const user = JSON.parse(storedHomework) || null;
    return {
        user,
        error: null,
    };
}


function createExtraActions() {
    const baseUrl = `https://api.webtracktechnologies.com.au:8002`;
   //const registerUrl = `${process.env.REACT_APP_API_URL}/frontend/auth/register/step-1`;

    return {
        getEssayListByTeacherId: getEssayListByTeacherId(),
        getEssayListByStudentId: getEssayListByStudentId(),
        createEssay: createEssay(),
updateEssay: updateEssay(),
        getEssayById: getEssayById(),
        searchEssayByTitle:searchEssayByTitle(),
        deleteEssayById:deleteEssayById(),
    };    

    function getEssayListByTeacherId() {
        return createAsyncThunk(
            `${name}/likewriter`,
            async ({ teacher_id}) => await fetchWrapper.get(`${baseUrl}/likewriter/essay/teacher/`+teacher_id)
        );
    }

    function getEssayListByStudentId() {
        return createAsyncThunk(
            `${name}/likewriter`,
            async ({ student_id}) => await fetchWrapper.get(`${baseUrl}/likewriter/essay/student/`+student_id)
        );
    }

    function createEssay() {
        return createAsyncThunk(
            `${name}/likewriter`,
            //async ({teacher_id,class_id,homework_email_text,category, type, homework_text}) => await fetchWrapper.post(`${baseUrl}/homework/create`,{teacher_id,class_id,homework_email_text,category, type, homework_text})
           async ({student_id,teacher_id,title,essay,character_count, word_count,sentence_count,vocabulary_use,grammar_mechanics,corrected_text,errors,content,organization,coherence_cohesion,total_score,lexile_score}) => await fetchWrapper.post(`${baseUrl}/likewriter/essay/create`,{student_id,teacher_id,title,essay,character_count, word_count,sentence_count,vocabulary_use,grammar_mechanics,corrected_text,errors,content,organization,coherence_cohesion,total_score,lexile_score})
        );
    }

   function updateEssay() {
        return createAsyncThunk(
            `${name}/likewriter`,
           async ({id,student_id,teacher_id,title,essay,character_count, word_count,sentence_count,vocabulary_use,grammar_mechanics,corrected_text,errors,content,organization,coherence_cohesion,total_score,lexile_score}) => await fetchWrapper.put(`${baseUrl}/likewriter/essay/update/${id}`,{student_id,teacher_id,title,essay,character_count, word_count,sentence_count,vocabulary_use,grammar_mechanics,corrected_text,errors,content,organization,coherence_cohesion,total_score,lexile_score})
        );
    }

    function getEssayById() {
        return createAsyncThunk(
            `${name}/likewriter`,
            async ({ essayid }) => await fetchWrapper.get(`${baseUrl}/likewriter/essay/single/`+essayid)
        );
    }

    function searchEssayByTitle() {
        return createAsyncThunk(
            `${name}/likewriter`,
            //async ({teacher_id,class_id,homework_email_text,category, type, homework_text}) => await fetchWrapper.post(`${baseUrl}/homework/create`,{teacher_id,class_id,homework_email_text,category, type, homework_text})
           async ({student_id,teacher_id,title}) => await fetchWrapper.post(`${baseUrl}/likewriter/essay/search`,{student_id,teacher_id,title })
        );
    }

    function deleteEssayById() {
        return createAsyncThunk(
            `${name}/likewriter`,
            //async ({teacher_id,class_id,homework_email_text,category, type, homework_text}) => await fetchWrapper.post(`${baseUrl}/homework/create`,{teacher_id,class_id,homework_email_text,category, type, homework_text})
           async ({essay_id}) => await fetchWrapper.delete(`${baseUrl}/likewriter/essay/${essay_id}`)
        );
    }

}

function createExtraReducers() {
    return {
        ...getEssayListByTeacherId(),
        ...createEssay(),
	...updateEssay(),
        ...getEssayListByStudentId(),
        ...searchEssayByTitle(),
        ...deleteEssayById(),
    };

    function getEssayListByTeacherId() {
        var { pending, fulfilled, rejected } = extraActions.getEssayListByTeacherId;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const likewriter = action.payload;
               
                state.likewriter = likewriter;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

    function createEssay() {
        var { pending, fulfilled, rejected } = extraActions.createEssay;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const likewriter = action.payload;
                state.likewriter = likewriter;
                toast.success('Essay saved successfully.', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

function updateEssay() {
        var { pending, fulfilled, rejected } = extraActions.updateEssay;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const likewriter = action.payload;
                state.likewriter = likewriter;
                toast.success('Essay updated successfully.', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }


    function getEssayListByStudentId() {
        var { pending, fulfilled, rejected } = extraActions.getEssayListByStudentId;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const likewriter = action.payload;
               
                state.likewriter = likewriter;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

    function searchEssayByTitle() {
        var { pending, fulfilled, rejected } = extraActions.searchEssayByTitle;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const likewriter = action.payload;
                state.likewriter = likewriter;
               
            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

    function deleteEssayById() {
        var { pending, fulfilled, rejected } = extraActions.deleteEssayById;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const likewriter = action.payload;
                state.likewriter = likewriter;
               
            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

}
